// extracted by mini-css-extract-plugin
export default {"itemWrapper":"callingItem_itemWrapper__ocxZ2"};